// DashboardService.js
import axiosInstance from "./AxiosInstance";


export function getTelecallerDashboard() {
  return axiosInstance.post("dashboard/Telecaller", {});
}

export function getReceptionistDashboard() {
  return axiosInstance.post("dashboard/Receptionist", {});
}


export function getDoctorDashboard() {
  return axiosInstance.post("dashboard/Doctor", {});
}


export function getCounsellorDashboard() {
  return axiosInstance.post("dashboard/Counsellor", {});
}

export function getMedicalDashboard() {
    return axiosInstance.post("/dashboard/Medical", {});
  }


export function getServiceCallerDashboard() {
  return axiosInstance.post("dashboard/ServiceCaller", {});
}
